<script lang="ts">
  type Props = {
    class?: string;
    small?: boolean;
    color?: string;
    dy: number;
    transform: string;
  };

  const props: Props = $props();
</script>

<circle
  class="handle {props.class}"
  cx="50%"
  cy={props.dy}
  r={props.small ? 6 : 12}
  fill={props.color}
  transform={props.transform}
/>

<style lang="scss">
  .handle {
    transition:
      all linear 0.5s,
      transform 0ms;
  }
</style>
